<template>
  <div class="py-8 lg:py-16" :class="model.background">
    <div class="container mx-auto max-w-screen-2xl">
      <div class="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-12">
        <div v-for="(item, index) in paginatedData" :key="index" class="flex flex-col">
          <VcImage :src="item.blogImage" class="mx-auto h-[300px] w-full rounded-xl object-cover" lazy />
          <div v-if="item.blogTitle" class="my-3 text-[22px] font-bold" :class="model.textColor">
            {{ item.blogTitle }}
          </div>

          <div v-if="item.blogText" class="leading-7" v-html-safe="item.blogText"></div>

          <VcButton v-if="item.blogUrl && item.blogLabel" v-bind="getLinkAttr(item.blogUrl)" class="mt-4 w-fit">
            {{ item.blogLabel }}
          </VcButton>
        </div>
      </div>
      <div class="pagination font-bold">
        <button
          v-if="page != 0"
          class="mr-2 text-[color:var(--color-secondary)-500] hover:text-[color:var(--color-primary-500)]"
          @click="page--"
        >
          &#8592;
        </button>
        <button
          v-for="(num, index) in pages"
          :key="index"
          class="relative mr-2 hover:text-[color:var(--color-primary-500)]"
          relative1
          :class="[page == index ? 'text-[color:var(--color-primary-500)]' : 'text-[color:var(--color-secondary)-500]']"
          @click="page = index"
        >
          {{ num }}
        </button>
        <button
          v-if="page != pages.length - 1"
          class="text-[color:var(--color-secondary)-500] hover:text-[color:var(--color-primary-500)]"
          @click="page++"
        >
          &#8594;
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getLinkAttr } from "@/core/utilities/common";
import { ref, computed } from "vue";

type BlogItems = {
  blogText: string;
  blogTitle: string;
  blogUrl: string;
  blogImage: string;
  blogLabel: string;
};

interface IProps {
  model: {
    background?: string;
    textColor?: string;
    blogs: BlogItems[];
  };
}

const props = defineProps<IProps>();

const perPage = 6;
const page = ref(0);

const paginatedData = computed(() => {
  const start = page.value * perPage;
  const end = start + perPage;
  return props.model.blogs.slice(start, end);
});

const pages = computed(() => Array.from({ length: Math.ceil(props.model.blogs.length / perPage) }, (_, i) => i + 1));
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
